export default class FreeDeliveryBanner extends HTMLElement {
    constructor() {
        super();

        this.cartSubtotal = Number(this.dataset.cartSubtotal) / 100;
        this.freeShippingThresholdAmount = null;

        this.init();
    }

    init () {
        if (document.querySelector('.js-product-free-delivery-info-loading')) {
            this.getShippingCalc();
        }

        this.attachEventListeners();
    }

    attachEventListeners () {
        window.addEventListener('cartChange', (event) => {
            if (event.detail.sections['cart-notification-total']) {
                const totalPrice = new DOMParser()
                    .parseFromString(event.detail.sections['cart-notification-total'], 'text/html')
                    .querySelector('[data-subtotal]')?.dataset?.subtotal || 0;

                if (totalPrice >= 0) {
                    if (document.querySelector('.js-product-free-delivery-info-loading')) {
                        this.getShippingCalc(totalPrice / 100);
                    }
                }
            }
        });
    }

    getShippingCalc (cartSubtotal = this.cartSubtotal) {
        this.freeShippingThresholdAmount = parseFloat(window.freeShippingThreshold) ?? null;

        if (this.freeShippingThresholdAmount) {
            document.querySelector('.js-product-free-delivery-info-loading')?.classList.add('hidden');

            if (cartSubtotal < this.freeShippingThresholdAmount) {
                if (document.querySelector('.js-product-free-delivery-not-qualified') && document.querySelector('.js-product-free-delivery-remaining-amount')) {
                    document.querySelector('.js-product-free-delivery-remaining-amount').innerHTML = parseFloat((this.freeShippingThresholdAmount - cartSubtotal)).toFixed(2);
                    document.querySelector('.js-product-free-delivery-not-qualified')?.classList.remove('hidden');
                    document.querySelector('.js-product-free-delivery-qualified')?.classList.add('hidden');
                }
            } else {
                document.querySelector('.js-product-free-delivery-not-qualified')?.classList.add('hidden');
                document.querySelector('.js-product-free-delivery-qualified')?.classList.remove('hidden');
            }
        }
    }
}
